import * as React from "react"
import {Link} from "gatsby"
import "./contact.css"

const Contact = () => {
    return (
        <section className="wrapper bg-light">
            <div className="container pt-8 py-md-9 pb-9 pb-md-10">
                <div className="row">
                    <div className="col-xl-10 mx-auto">
                        <div className="card">
                            <div className="row gx-0">
                                <div className="col-lg-6 align-self-stretch">
                                    <div className="map map-full rounded-top rounded-lg-start">
                                        <iframe
                                            src="https://maps.google.com/maps?q=Texbond%20Nonwovens,%20chennai&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="p-10 p-md-11 p-lg-14">
                                        <div
                                            data-sal="fade"
                                            data-sal-delay="200"
                                            data-sal-easing="easeInExpo"
                                            className="d-flex flex-row"
                                        >
                                            <div>
                                                <div className="icon text-orange fs-28 me-4 mt-n1">
                                                    <i className="bi bi-geo-alt"/>
                                                </div>
                                            </div>
                                            <div className="align-self-start justify-content-start">
                                                <h5 className="mb-1">
                                                    Address
                                                </h5>
                                                <address>
                                                    T4, K.G.Plaza,
                                                    41-44, General Patters Road,
                                                    Chennai, India – 600002
                                                </address>
                                            </div>
                                        </div>
                                        <div
                                            data-sal="fade"
                                            data-sal-delay="400"
                                            data-sal-easing="easeInExpo"
                                            className="d-flex flex-row"
                                        >
                                            <div>
                                                <div className="icon text-orange fs-28 me-4 mt-n1">
                                                    <i className="bi bi-telephone"/>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <h5 className="mb-1">
                                                    Phone
                                                </h5>
                                                <div>
                                                    <p className="p-0 m-0">
                                                        +91-9500980708
                                                    </p>
                                                    <p className="p-0 m-0">
                                                        +91-9500980718
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            data-sal="fade"
                                            data-sal-delay="600"
                                            data-sal-easing="easeInExpo"
                                            className="d-flex flex-row"
                                        >
                                            <div>
                                                <div className="icon text-orange fs-28 me-4 mt-n1">
                                                    <i className="bi bi-envelope"/>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="mb-1">
                                                    E-mail
                                                </h5>
                                                <p className="mb-0">
                                                    <a href="mailto:sales@texbond.in"
                                                       className="link-body">
                                                        sales@texbond.in
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact